/**
 * promos.js
 * Handles: signup bar, cookies popup, US duties banner,
 * Klaviyo teaser positioning & text rotation, promo popup modals,
 * tab navigation for sale points.
 */
(function() {
  'use strict';

  /* ================================================================
   * 1. COOKIE UTILITIES
   * ================================================================ */
  function createCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toGMTString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  }

  function readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  }

  /* ================================================================
   * 2. SIGNUP BAR & COOKIES POPUP
   * ================================================================ */
  $(document).ready(function() {
    // Show subscribe button if no hide cookie
    if (!readCookie('hide_popup_signup')) {
      setTimeout(function() {
        $('#botonSubscribirseFijo').fadeIn(500, function() {
          $(this).css('opacity', '1');
        });
      }, 2000);
    }

    // Close signup bar and set cookie
    $('#signup_bar_close span').click(function() {
      $('#signup_bar').fadeOut(500);
      createCookie('hide_popup_signup', true, 0);
      return false;
    });

    // Show cookies popup if no hide cookie
    if (!readCookie('hide_popup_cookies')) {
      $('.popup.cookies').show();
    }

    // Close cookies popup (365 day cookie)
    $('.close-cookies').click(function() {
      $('.popup.cookies').hide();
      createCookie('hide_popup_cookies', true, 365);
      return false;
    });
  });

  /* ================================================================
   * 3. US DUTIES BANNER & KLAVIYO TEASER POSITIONING
   * ================================================================ */
  if (window.location.pathname.indexOf('/en-us') !== -1 || window.location.pathname.indexOf('/es-us') !== -1) {
    if (window.innerWidth > 999) {
      var bannerEl = document.querySelector('#banner-duties-us');
      if (bannerEl) bannerEl.style.cssText = 'opacity: 1;';
    } else {
      var usHeaderEl = document.querySelector('.us-header');
      if (usHeaderEl) usHeaderEl.style.cssText = 'display: block;';
    }
  }

  var topMaximo = 0;

  function actualizarPosicionBoton() {
    var wrapper = document.querySelector('#shopify-section-header .wrapper');
    var boton = document.querySelector('.kl-teaser-VWFyyx');
    var onlywrapper = document.querySelector('.wrapper');
    var onlyAnnouncement = document.querySelector('.announcement');

    if (!wrapper || !boton) return;

    var baseHeight = wrapper.offsetHeight;
    var baseonlywrapper = onlywrapper.offsetHeight;
    var baseAnnouncement = onlyAnnouncement ? onlyAnnouncement.offsetHeight : 0;

    function ajustarTopSegunScroll() {
      var scrollY = window.scrollY || window.pageYOffset;
      var extra = scrollY > 0 ? -2 : 90 + baseonlywrapper - baseHeight + baseAnnouncement;
      var nuevoTop;

      if (scrollY === 0) {
        nuevoTop = baseonlywrapper + baseHeight + 30 + baseAnnouncement;
        nuevoTop = nuevoTop + 20;

        var usHeader = document.querySelector('.us-header');
        if (usHeader && window.getComputedStyle(usHeader).display === 'block') {
          nuevoTop = nuevoTop + 30;
        }

        if (topMaximo === 0) {
          topMaximo = nuevoTop;
        }
      } else {
        nuevoTop = baseonlywrapper + extra;
        nuevoTop = nuevoTop + 10;
      }

      // Ensure teaser never overlaps the sticky menu-collection bar
      var menuCollection = document.querySelector('.menu-collection');
      if (menuCollection) {
        var menuBottom = menuCollection.getBoundingClientRect().bottom;
        if (nuevoTop < menuBottom + 5) {
          nuevoTop = menuBottom + 5;
        }
      }

      if (nuevoTop <= topMaximo) {
        boton.style.top = nuevoTop + 'px';
        boton.style.margin = '0px 20px';
        setTimeout(function() {
          boton.style.opacity = 1;
          boton.style.pointerEvents = 'auto';
        }, 2000);
      }
    }

    ajustarTopSegunScroll();
    var scrollTicking = false;
    window.addEventListener('scroll', function() {
      if (!scrollTicking) {
        requestAnimationFrame(function() {
          ajustarTopSegunScroll();
          scrollTicking = false;
        });
        scrollTicking = true;
      }
    });
    window.addEventListener('resize', function() {
      var newBaseHeight = wrapper.offsetHeight;
      if (newBaseHeight !== baseHeight) {
        ajustarTopSegunScroll();
      }
    });
  }

  function actualizarPosicionBotonPc() {
    var boton = document.querySelector('.kl-teaser-VWFyyx');
    var onlyAnnouncement = document.querySelector('.announcement');
    var bannerUS = document.querySelector('#banner-duties-us');
    var baseAnnouncement = onlyAnnouncement ? onlyAnnouncement.offsetHeight : 0;

    if (!boton) return;

    function ajustarTopSegunScroll() {
      var scrollY = window.scrollY || window.pageYOffset;

      if (scrollY === 0) {
        if (onlyAnnouncement) {
          boton.style.top = '140px';
          if (bannerUS) bannerUS.style.top = '205px';
        } else {
          boton.style.top = '90px';
          if (bannerUS) bannerUS.style.top = '155px';
        }
        boton.style.margin = '0px 20px';
      } else if (scrollY >= 160) {
        boton.style.top = '70px';
        boton.style.margin = '0px 20px';
        if (bannerUS) bannerUS.style.top = '135px';
      }

      setTimeout(function() {
        boton.style.opacity = 1;
        boton.style.pointerEvents = 'auto';
      }, 2000);
    }

    ajustarTopSegunScroll();
    var scrollTickingPc = false;
    window.addEventListener('scroll', function() {
      if (!scrollTickingPc) {
        requestAnimationFrame(function() {
          ajustarTopSegunScroll();
          scrollTickingPc = false;
        });
        scrollTickingPc = true;
      }
    });
    window.addEventListener('resize', function() {
      ajustarTopSegunScroll();
    });
  }

  // Klaviyo teaser — MutationObserver
  var teaserEnganchado = false;

  function revisarTeaser() {
    var boton = document.querySelector('.kl-teaser-VWFyyx');
    if (boton && !teaserEnganchado) {
      teaserEnganchado = true;
      if (window.innerWidth < 1001) {
        actualizarPosicionBoton();
      } else {
        actualizarPosicionBotonPc();
      }
      // Breadcrumbs (.content-util) and menu-collection both have
      // z-index: 991, above the teaser's 990 !important, so they
      // are always clickable even when the teaser overlaps.
    } else if (!boton) {
      teaserEnganchado = false;
    }
  }

  var teaserObserver = new MutationObserver(function() {
    revisarTeaser();
    if (teaserEnganchado) teaserObserver.disconnect();
  });
  teaserObserver.observe(document.body, { childList: true, subtree: true });
  revisarTeaser();

  /* ================================================================
   * 4. KLAVIYO TEASER TEXT ROTATION
   * ================================================================ */
  var textos = ['FREE WORLDWIDE SHIPPING*', '1 YEAR WARRANTY', '60 DAYS RETURNS', 'SUBSCRIBE AND GET 10% OFF >'];

  function esperarElemento(selector, callback) {
    var el = document.querySelector(selector);
    if (el) { callback(el); return; }
    var obs = new MutationObserver(function() {
      el = document.querySelector(selector);
      if (el) { obs.disconnect(); callback(el); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  esperarElemento('.kl-teaser-VWFyyx .go3176171171 span', function(spanTexto) {
    var indice = 0;
    var cajaSpanTexto = document.querySelector('.kl-teaser-VWFyyx div span');
    if (cajaSpanTexto) cajaSpanTexto.classList.add('fondo-marron');

    function cambiarTexto() {
      spanTexto.style.opacity = 0;
      setTimeout(function() {
        spanTexto.textContent = textos[indice];
        if (indice === textos.length - 1) {
          var caja = document.querySelector('.kl-teaser-VWFyyx div span');
          if (caja) caja.classList.remove('fondo-marron');
          clearInterval(intervalo);
        }
        spanTexto.style.opacity = 1;
        indice++;
      }, 500);
    }

    cambiarTexto();
    var intervalo = setInterval(cambiarTexto, 5000);
  });

  /* ================================================================
   * 5. PROMO POPUP MODALS
   * ================================================================ */
  // promoPopup (promo-popup-new)
  var modalpromo = document.getElementById('promoPopup');
  var btnpromo = document.getElementById('promoBtnPopup');
  var spanpromo = document.getElementById('promoClose');
  var btnpromoFijo = document.getElementById('botonSubscribirseFijo');

  if (btnpromo && modalpromo) {
    btnpromo.addEventListener('click', function() {
      modalpromo.style.display = 'block';
      modalpromo.style.opacity = '1';
      modalpromo.style.visibility = 'visible';
      var content = document.querySelector('.modal-content-promo');
      if (content) { content.style.opacity = '1'; content.style.visibility = 'visible'; }
    });
  }

  if (btnpromoFijo && modalpromo) {
    btnpromoFijo.addEventListener('click', function() {
      var textoSpan = document.getElementById('textoSubscribirseFijo');
      if (textoSpan && textoSpan.textContent.indexOf('10%') !== -1) {
        modalpromo.style.display = 'block';
        modalpromo.style.opacity = '1';
        modalpromo.style.visibility = 'visible';
        var content = document.querySelector('.modal-content-promo');
        if (content) { content.style.opacity = '1'; content.style.visibility = 'visible'; }
      }
    });
  }

  if (spanpromo && modalpromo) {
    spanpromo.addEventListener('click', function() {
      modalpromo.style.display = 'none';
    });
  }

  window.addEventListener('click', function(event) {
    if (modalpromo && event.target === modalpromo) {
      modalpromo.style.display = 'none';
    }
  });

  // promoPopupComing
  document.addEventListener('DOMContentLoaded', function() {
    var modal = document.getElementById('promoPopupComing');
    if (!modal) return;

    var triggers = document.querySelectorAll('.subscribe-coming');
    var closeBtn = document.getElementById('promoClose');

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        modal.classList.add('show');
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        modal.classList.remove('show');
      });
    }

    window.addEventListener('click', function(e) {
      if (e.target === modal) {
        modal.classList.remove('show');
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        modal.classList.remove('show');
      }
    });
  });

  /* ================================================================
   * 6. TAB NAVIGATION (Sale Points)
   * ================================================================ */
  window.openTab = function(evt, promoTab) {
    var i, tabcontent, tablinks;
    var isAlreadyActive = evt.currentTarget.className.indexOf('active') !== -1;

    tabcontent = document.getElementsByClassName('tab-content2');
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none';
    }
    tablinks = document.getElementsByClassName('tab-links');
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(' active', '');
    }

    if (!isAlreadyActive) {
      var tabEl = document.getElementById(promoTab);
      if (tabEl) tabEl.style.display = 'block';
      evt.currentTarget.className += ' active';
    }
  };

})();
